<template>
    <v-container fluid>

        <!-- Release name -->
        <v-col :alvqa="alvqa + '-title'">
            <v-row class="pl-4 headline">
                {{ item.name }}
            </v-row>
        </v-col>

        <v-row class="pl-4 pr-4 pt-3">
            <!-- 1st Col -->
            <v-col 
                cols="1" 
                v-if="item.cover !== undefined && item.cover !== null"
            >
                <v-img 
                    :src="item.cover"
                    :alvqa="alvqa + '-image'"
                ></v-img>
            </v-col>
            <v-col v-if="showFirstCard">
                <v-card 
                    height="100%"
                    elevation="0"
                >
                    <v-card-text>
                        <!-- DISPLAY ARTIST --> 
                        <span v-if="item.displayArtist !== null">
                            <div
                                    class="read-only-caption"
                                    :alvqa="alvqa + '-caption-display-artist'"
                                >{{ $t('lang_LABEL_RELEASE_CAPTION_DISPLAY_ARTIST') }}
                                <img
                                    @click="showHelpOverlay = true"
                                    src="@/assets/logo/yt_icon_rgb.png"
                                    alt="YouTube"
                                    style="height: 12px; cursor: pointer; margin-left: 4px; filter: grayscale(100%) opacity(50%);"
                                />
                            </div>
                            <div :alvqa="alvqa + '-display-artist'">
                                {{ item.displayArtist }}
                            </div>
                        </span>
                        
                        <!-- ARTIST --> 
                        <span v-if="getAzName">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-artist'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_ARTIST') }}</div>
                            <div :alvqa="alvqa + '-artist'">
                                {{ getAzName }}
                            </div>
                            <template v-if="item.performer.alvId">
                                <router-link :to="$alvPlugin.createUrlForAlvId(item.performer.alvId)">{{ item.performer.alvId }}</router-link>
                            </template>
                        </span>
                        <!-- MEDIA TYPE -->
                        <span v-if="item.mediaType !== null">
                            
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-media-type'"
                            >{{ $t('lang_LABEL_RELEASES_CAPTION_MEDIA_TYPE') }}</div>
                            <div :alvqa="alvqa + '-media-type'">
                                {{ getMediaType(item.mediaType) }}
                            </div>
                        </span>
                        <!-- GENRES -->
                        <span v-if="item.genre1 !== null || item.genre2 !== null || item.genre3 !== null">
                            
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-genres'"
                            >{{ $t('lang_LABEL_RELEASES_CAPTION_GENRES') }}</div>
                            <div 
                                v-if="item.genre1 !== null"
                                :alvqa="alvqa + '-genre-1'" 
                            >{{ getGenre(item.genre1) }}</div>
                            <div 
                                v-if="item.genre2 !== null"
                                :alvqa="alvqa + '-genre-2'"
                            >{{ getGenre(item.genre2) }}</div>
                            <div 
                                v-if="item.genre3 !== null"
                                :alvqa="alvqa + '-genre-3'" 
                            >{{ getGenre(item.genre3) }}</div>
                        </span>
                        <!-- NOTES -->
                        <span v-if="item.notes !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-notes'"
                            >{{ $t('lang_GENERAL_CAPTION_NOTES') }}</div>
                            <div :alvqa="alvqa + '-notes'">
                                {{ item.notes }}
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col v-if="showSecondCard">
                <v-card 
                    height="100%"
                    elevation="0"
                >
                    <v-card-text>
                        <!-- EAN/UPC -->
                        <span v-if="item.ean !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-ean-upc'"
                            >{{ $t('lang_LABEL_RELEASES_CAPTION_EAN_UPC') }}</div>
                            <div :alvqa="alvqa + '-ean-upc'">
                                {{ item.ean }}
                            </div>
                        </span>
                        <!-- CATALOGUE Number -->
                        <span v-if="item.catalogueNumber !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-catalogue-number'"
                            >{{ $t('lang_LABEL_RELEASES_CAPTION_CATALOGUE_NUMBER') }}</div>
                            <div :alvqa="alvqa + '-catalogue-number'">
                                {{ item.catalogueNumber }}
                            </div>
                        </span>
                        <!-- Label -->
                        <span>
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-label-company'"
                            >{{ $t('lang_LABEL_RELEASE_LABEL') }}</div>
                            <div :alvqa="alvqa + '-label-company'">
                                {{ getLabelOfRelease.text }} (<router-link :to="`/az/azgroups/${getLabelOfRelease.alvId}`">{{ getLabelOfRelease.alvId }}</router-link>)
                            </div>
                        </span>
                        <!-- OTHER IDs -->
                        <span v-if="item.otherId !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-other-id'"
                            >{{ $t('lang_LABEL_RELEASES_CAPTION_OTHER_ID') }}</div>
                            <div :alvqa="alvqa + '-other-id'">
                                {{ item.otherId }}
                            </div>
                        </span>
                        <!-- GEMA CATALOGUE Number -->
                        <span v-if="item.gemaCatalogueNumber !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-gema-catalogue-number'"
                            >{{ $t('lang_LABEL_RELEASE_GEMA_CATALOGUE_NO') }}</div>
                            <div :alvqa="alvqa + '-gema-catalogue-number'">
                                {{ item.gemaCatalogueNumber }}
                            </div>
                        </span>
                        <!-- GEMA REGISTRATION Number -->
                        <span v-if="item.gemaRegistrationNumbers !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-gema-registration-number'"
                            >{{ $t('lang_LABEL_RELEASE_GEMA_REG_NO') }}</div>
                            <div :alvqa="alvqa + '-gema-registration-number'">
                                {{ item.gemaRegistrationNumbers }}
                            </div>
                        </span>
                        <!-- GEMA LTN Number -->
                        <span v-if="item.gemaLtnNumber !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-gema-ltn-number'"
                            >{{ $t('lang_LABEL_RELEASES_CAPTION_GEMA_LTN_NUMBER') }}</div>
                            <div :alvqa="alvqa + '-gema-ltn-number'">
                                {{ item.gemaLtnNumber }}
                            </div>
                        </span>
                        <!-- ALVID -->
                        <span v-if="item.alvId !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-alvid'"
                            >{{ $t('lang_GENERIC_CAPTION_ALVID') }}</div>
                            <div :alvqa="alvqa + '-alvid'">
                                {{ item.alvId }}
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col v-if="showThirdCard">
                <v-card 
                    height="100%"
                    elevation="0"
                >
                    <v-card-text>
                        <!-- Minimum Stock -->
                        <span v-if="item.minimumStock !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-minimum-stock'"
                            >{{ $t('lang_LABEL_RELEASES_CAPTION_MINIMUM_STOCK') }}</div>
                            <div :alvqa="alvqa + '-minimum-stock'">
                                {{ item.minimumStock }}
                            </div>
                        </span>
                        <!-- Number of discs -->
                        <span v-if="item.numberOfDiscs !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-number-of-discs'"
                            >{{ $t('lang_LABEL_RELEASES_CAPTION_NUMBER_OF_DISCS') }}</div>
                            <div :alvqa="alvqa + '-number-of-discs'">
                                {{ item.numberOfDiscs }}
                            </div>
                        </span>
                        <!-- Weight of release (for shipping) -->
                        <span v-if="item.weight !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-weight'"
                            >{{ $t('lang_LABEL_RELEASE_CAPTION_WEIGHT') }}</div>
                            <div :alvqa="alvqa + '-weight'">
                                {{ item.weight }}
                            </div>
                        </span>
                        <!-- RETAIL DATE -->
                        <span v-if="item.dateRetail !== null && item.dateRetail !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-retail-date'"
                            >{{ $t('lang_LABEL_RELEASES_CAPTION_DATE_PHYSICAL') }}</div>
                            <div :alvqa="alvqa + '-retail-date'">
                                {{ getFormattedDate(item.dateRetail) }}
                            </div>
                        </span>
                        <!-- DIGITAL Date -->
                        <span v-if="item.dateDigital !== null && item.dateDigital !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-digital-release-date'"
                            >{{ $t('lang_LABEL_RELEASE_DATE_DIGITAL') }}</div>
                            <div :alvqa="alvqa + '-digital-release-date'">
                                {{ getFormattedDate(item.dateDigital) }}
                            </div>
                        </span>
                        <!-- PRERELEASE Date -->
                        <span v-if="item.datePreRelease !== null && item.datePreRelease !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-prerelease-date'"
                            >{{ $t('lang_LABEL_RELEASE_DATE_PRERELEASE') }}</div>
                            <div :alvqa="alvqa + '-prerelease-date'">
                                {{ getFormattedDate(item.datePreRelease) }}
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col v-if="showFourthCard">
                <v-card 
                    height="100%"
                    elevation="0"
                >
                    <v-card-text>
                        <!-- PRICE CATEGORY -->
                        <span v-if="item.priceCategory !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-price-category'"
                            >{{ $t('lang_LABEL_RELEASES_CAPTION_PRICE_CATEGORY') }}</div>
                            <div :alvqa="alvqa + '-price-category'">
                                
                                {{ $t(getPriceCategory(item.priceCategory)) }}
                            </div>
                        </span>
                        <!-- PRICELIST TITLE -->
                        <span v-if="item.selectedPriceListTitle !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-pricelist-title'"
                            >{{ $t('lang_GENERIC_CAPTION_PRICELIST') }}</div>
                            <div :alvqa="alvqa + '-pricelist-title'">
                                
                                {{ item.selectedPriceListTitle }}
                            </div>
                        </span>
                        <!-- LANGUAGE -->
                        <span v-if="item.language !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-language'"
                            >{{ $t('lang_LABEL_RELEASES_CAPTION_LANGUAGE') }}</div>
                            <div :alvqa="alvqa + '-language'">
                                {{ $t(getLanguage) }}
                            </div>
                        </span>
                        <!-- TAGS -->
                        <span v-if="item.tags !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-tags'"
                            >{{ $t('lang_LABEL_RELEASES_CAPTION_TAGS') }}</div>
                            <div :alvqa="alvqa + '-tags'">
                                {{ item.tags }}
                            </div>
                        </span>
                        <!-- CONTRACTS -->
                        <span v-if="item.contracts !== null && item.contracts.length !== 0">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-contracts'"
                            >{{ $t('lang_LABEL_RELEASES_CAPTION_CONTRACTS') }}:</div>
                            <div
                                v-for="(contract, i) in item.contracts"
                                :key="i"
                                :alvqa="alvqa + '-contracts-' + contract.contract.alvId"
                            >
                                <BaseTooltip>
                                    <template v-if="contract.contract.licensor != null" v-slot:text>{{ contract.contract.licensor.name }} ({{ contract.contract.licensor.alvId }})</template>
                                    <template v-else v-slot:text>{{ $t("lang_GENERIC_CONTRACTS_ERROR_NO_LICENSOR") }}</template>
                                    <template v-slot:content>
                                        {{ contract.contract.contractName }} 
                                        <router-link :to="`/contracts/label/${contract.contract.alvId }`">
                                        {{ contract.contract.alvId  }}</router-link>
                                        {{ contract.connectedTracks }} {{ $t("lang_GENERIC_CAPTION_OF") }} {{ item.tracks }} {{ $t("lang_GENERIC_TRACKS_PLURAL_SMALLCAP") }}
                                    </template>
                                </BaseTooltip>
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="ml-4 mr-4">
                <v-expansion-panels multiple focusable tile flat>
                    <TracksReadOnlyPanel :releaseAlvId="item.alvId" />
                    <ReleasesArtistsReadOnlyPanel :releaseAlvId="item.alvId" />
                    <ReleasePromotionalTextsReadOnlyPanel :releaseAlvId="item.alvId" />
                    <ReleasesOtherIdsReadOnlyPanel :releaseAlvId="item.alvId" />
                    <ReleasesProfitAndLossReadOnlyPanel :releaseAlvId="item.alvId" />
                    <ReleasesDigitalDistributionPanel :releaseAlvId="item.alvId" />
                </v-expansion-panels>
            </v-col>
        </v-row>

        <!-- Overlay Dialog -->
        <v-dialog v-model="showHelpOverlay" max-width="360px" max-height="640px">
            <v-card style="background-color: #f0f0f0;">
                <v-card-title>
                    <v-spacer></v-spacer>
                    <BaseIcon
                        :alvqa="alvqa + '-icon-dialog-close'"
                        :small="true"
                        icon="close"
                        color="buttonStandard"
                        @click.stop="showHelpOverlay = false"
                        style="cursor: pointer;"
                    />
                </v-card-title>
                <v-card-text>
                    <div style="position: relative; padding-bottom: 177.78%; height: 0; overflow: hidden;">
                        <iframe
                            id="videoPlayer"
                            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
                            :src="youtubeUrl"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                            @load="setupVideoPlayer"
                        ></iframe>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import { DropdownGeneralPriceCategories,DropdownLabelReleasesMediaTypes } from '@/assets/dropdowns/alvDropdowns.js'

import TracksReadOnlyPanel from './_panels/2_tracks/TracksReadOnlyPanel'
import ReleasesDigitalDistributionPanel from './_panels/4_distribution/ReleasesDigitalDistributionReadOnlyPanel'
import ReleasesArtistsReadOnlyPanel from './_panels/1_artists/ReleasesArtistsReadOnlyPanel'
import ReleasePromotionalTextsReadOnlyPanel from './_panels/3_promotionalTexts/ReleasePromotionalTextsReadOnlyPanel'
import ReleasesProfitAndLossReadOnlyPanel from './_panels/5_profitLoss/ReleasesProfitAndLossReadOnlyPanel'
import ReleasesOtherIdsReadOnlyPanel from './_panels/6_otherids/ReleasesOtherIdsReadOnlyPanel'
import BaseTooltip from '@/components/_base/BaseTooltip'
import BaseIcon from '@/components/_buttons/BaseIcon'

export default {
    name: "LabelReleaseReadOnly",
    components: {
        TracksReadOnlyPanel,
        ReleasesDigitalDistributionPanel,
        ReleasesArtistsReadOnlyPanel,
        ReleasePromotionalTextsReadOnlyPanel,
        ReleasesProfitAndLossReadOnlyPanel,
        ReleasesOtherIdsReadOnlyPanel,
        BaseTooltip,
        BaseIcon,
    },
    props: {
        itemId: {
            type: Number
        }
    },
    data() {
        return {
            showHelpOverlay: false, // Controls visibility of the overlay
            youtubeUrl: 'https://www.youtube.com/embed/5j0WcYS5vUM?autoplay=1&enablejsapi=1', // Replace with your YouTube Shorts URL
            alvqa: 'label-releases-list-row-' + this.itemId + '-read-only'
        }
    },
    computed: {
        item() { return this.$store.getters.getExpandedLabelReleases[0] },
        showFirstCard() {
            let showPerformer = this.item.performer !== null
            let showMediaType = this.item.mediaType !== null
            let showNotes = this.item.notes !== null
            
            if(showPerformer || showMediaType || showNotes) return true
            else return false
        },
        getAzName() {
              return this.$store.getters.getLabelReleasesDetailsConnectedArtist;
        },
        getLabelOfRelease(){ 
            let allLabels = this.$store.getters.getLabelReleaseLabelsDropdown 
            let selectedReleaseLabelId = this.$store.getters.getLabelReleasesDetailsSelectedLabelId
            
            let selectedLabelObject = allLabels.find(label => {
                    return label.value === selectedReleaseLabelId
            })
            return selectedLabelObject       
        },
        showSecondCard() {
            let showCatalogueNumber = this.item.catalogueNumber !== null
            let showEan = this.item.ean !== null
            let showOtherId = this.item.otherId !== null
            let showGemaCatNo = this.item.gemaCatalogueNumber !== null
            let showGemaRegNo = this.item.gemaRegistrationNumbers !== null
            let showGemaLtnNo = this.item.gemaLtnNumber !== null
            

            if(showCatalogueNumber || showEan || showOtherId || showGemaCatNo || showGemaRegNo || showGemaLtnNo) return true
            else return false
            
        },

        showThirdCard() {
            let showRetailDate = this.item.dateRetail !== null && this.item.dateRetail !== ''
            let showDateDigital = this.item.dateDigital !== null && this.item.dateDigital !== ''
            let showDatePreRelease = this.item.datePreRelease !== null && this.item.datePreRelease !== ''

            if(showRetailDate || showDateDigital || showDatePreRelease) return true
            else return false
        },
        showFourthCard() {
            let showPriceCat = this.item.priceCategory !== null
            let showLanguage = this.item.language !== null
            let showTags = this.item.tags !== null
            let showContracts = this.item.contracts !== null

            if(showPriceCat || showLanguage || showTags || showContracts) return true
            else return false
        },
        getLanguage() {
            let languages = this.$alvPlugin.getListOfGenericMusicLanguages('label-releases')
            let selectedLanguage = this.item.language.toLowerCase()

            let match = languages.find(language => {
                return language.value === selectedLanguage
            })

            return match.text
        },
    },
    methods: {
        getFormattedDate(date) {  
            if(date === null || date === undefined || !date.match(/^\d{4}-\d{2}-\d{2}$/)) return ''
            else return this.$d(new Date(date), 'alvDateFormat') 
        },

        getMediaType(value) { 
            let mediaTypesDb = DropdownLabelReleasesMediaTypes
            
            let text =  mediaTypesDb.find(type => {
                return type.value === value
            }).text
            return this.$t(text)
        },

        setupVideoPlayer() {
            window.onYouTubeIframeAPIReady = () => {
                const player = new YT.Player('videoPlayer', {
                    events: {
                        onStateChange: this.onPlayerStateChange,
                    },
                });
            };

            // Load YouTube IFrame API script if not already loaded
            if (!window.YT) {
                const tag = document.createElement('script');
                tag.src = 'https://www.youtube.com/iframe_api';
                const firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            } else {
                window.onYouTubeIframeAPIReady();
            }
        },
        onPlayerStateChange(event) {
            if (event.data === YT.PlayerState.ENDED) {
                this.showHelpOverlay = false; // Close the dialog when the video ends
            }
        },

        getGenre(value) {
            let genresDb = this.$store.getters['getGenres' + this.$i18n.locale.toUpperCase()]

            if(genresDb !== undefined) {
                return genresDb.find(genre => {
                    return genre.value === value
                }).text
            }
        },

        getPriceCategory(priceCategoryValue) {
            return DropdownGeneralPriceCategories.find(priceCategory => {
                return priceCategory.value == priceCategoryValue
            }).text
        }
    },
    created() {
        this.$store.commit('setGenres')
    }
}
</script>